import { MODIFY_WORKFLOW, RESET_WORKFLOW } from '../types';

export const setCampaignWorkflow = (workflow) => ({
  type: MODIFY_WORKFLOW,
  payload: workflow,
});

export const resetWorkflow = () => ({
  type: RESET_WORKFLOW,
  payload: null,
});
